import { CTA_CLICK_LINK, ALLOWED_CTALINKS_BASE_URL } from "../constants/Common";

export const appendQueryParamsToUrl = (url, queryParams = "") => {
  if (url) {
    const urlInstance = new URL(url);
    return `${urlInstance.href}${
      queryParams ? (urlInstance?.search ? "&" : "?") : ""
    }${queryParams}`;
  }
  return "";
};

export const signupCtaHandler = (queryParams = "") => {
  const searchParams = new URLSearchParams(queryParams);
  if (
    searchParams?.get("cta-link") &&
    validateLinkParam(searchParams.get("cta-link"))
  ) {
    window.open(searchParams.get("cta-link"));
  } else {
    window?.open(appendQueryParamsToUrl(CTA_CLICK_LINK, queryParams));
  }
};

const validateLinkParam = (ctaLink) => {
  if (ALLOWED_CTALINKS_BASE_URL?.length) {
    let isAcceptedLink = false;
    ALLOWED_CTALINKS_BASE_URL.forEach((url) => {
      if (
        !isAcceptedLink &&
        ctaLink &&
        decodeURIComponent(ctaLink).startsWith(url)
      ) {
        isAcceptedLink = true;
      }
    });
    return isAcceptedLink;
  }
  return false;
};
